import { inject, injectable } from 'inversify';
import Debug from 'debug';
import { CommandHandler, createCommand } from '@/app/tracking/api';
import { XApiClient } from '@/app/tracking/xapi/tincan/client';
import { CompleteExamTrackingCommand, CompleteExamTrackingCommandPayload } from '../api'
import { ExamSuspendDataStore, calculateEffecticeGrade } from '../common';
import { createExamPassedStatement } from './exam-passed-statement';
import { createExamFailedStatement } from './exam-failed-statement';

const debug = Debug('xapi-complete-exam-command-handler')

@injectable()
export class XApiCompleteExamCommandHandler implements CommandHandler<CompleteExamTrackingCommand> {

  constructor (
    @inject(ExamSuspendDataStore)
    private examStore: ExamSuspendDataStore,
    @inject(XApiClient)
    private client: XApiClient
  ) {}
  
  public async execute(command: CompleteExamTrackingCommandPayload) {

    debug('execute', command)

    await this.examStore.execute(createCommand<CompleteExamTrackingCommand>('complete-exam', command))

    const effectiveGrade = await calculateEffecticeGrade(this.examStore)(command.id, command.effectiveGrading)
    if (effectiveGrade) {
      // TODO: what to do with the effective grade
    }

    // TODO: factory
    const { id, meta, attempt } = command;
    const params = {
      id: id,
      title: meta.title
    };
    let statement;
    switch (attempt.result) {
      case 'passed':
        statement = createExamPassedStatement(params);
        break;
      case 'failed':
        statement = createExamFailedStatement(params);
        break;
      default:
        return;
    }

    await this.client.sendStatement(statement);
  }
}
